/**
 * Константы типов элементов (Element Types)
 *
 * Единый источник правды для цветов и названий типов элементов.
 * Используется в: ElementStatsChart, ElementStatsWidget
 */

export const ELEMENT_TYPES = [
  { code: 'calls', name: 'Звонки', color: '#228BE6' },
  { code: 'messages', name: 'Сообщения', color: '#40C057' },
  { code: 'meetings', name: 'Встречи', color: '#7950F2' },
  { code: 'master_classes', name: 'Мастер-классы', color: '#FA5252' },
  { code: 'contacts', name: 'Контакты', color: '#FD7E14' },
  { code: 'contracts', name: 'Договоры', color: '#12B886' },
  { code: 'requisites', name: 'Реквизиты', color: '#495057' },
];

// Маппинг кода в метаданные
export const ELEMENT_TYPE_BY_CODE = ELEMENT_TYPES.reduce((acc, type) => {
  acc[type.code] = type;
  return acc;
}, {});

// Периоды для селектора (переиспользуем из cooperationStages)
export const PERIOD_OPTIONS = [
  { value: 'month', label: 'Месяц' },
  { value: '3months', label: '3 месяца' },
  { value: '6months', label: '6 месяцев' },
  { value: 'year', label: 'Год' },
];

// Гранулярность для селектора (переиспользуем из cooperationStages)
export const GRANULARITY_OPTIONS = [
  { value: 'daily', label: 'День' },
  { value: 'weekly', label: 'Неделя' },
  { value: 'monthly', label: 'Месяц' },
];

export default ELEMENT_TYPES;
